<template>
  <div class="surface-section px-4 py-5">
    <div class="flex align-items-center justify-content-center mt-0 mb-0">
      <h4><strong>ODONTOGRAMA</strong></h4>
    </div>

    <div class="field col-12 mb-3">
      <div style="display: flex; flex-wrap: wrap; gap: 6px 14px; justify-content: center">
        <span
          v-for="cond in condiciones"
          :key="cond.value"
          style="
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-size: 12px;
            font-weight: 600;
            padding: 3px 10px;
            border-radius: 12px;
            border: 1px solid #ccc;
            background: #fff;
          "
        >
          <span
            :style="{
              display: 'inline-block',
              width: '14px',
              height: '14px',
              borderRadius: '3px',
              background: cond.color,
              border: cond.value === 'sano' ? '1px solid #999' : 'none'
            }"
          ></span>
          {{ cond.label }}
        </span>
      </div>
    </div>

    <div v-if="superficieActiva" class="selector-condicion" :style="selectorStyle" @click.stop>
      <div class="selector-header">Diente {{ superficieActiva.diente }} - {{ superficieActiva.label }}</div>
      <div class="selector-opciones">
        <button
          v-for="cond in condiciones"
          :key="cond.value"
          class="btn-condicion"
          :style="{
            backgroundColor: cond.color,
            color: cond.value === 'sano' ? '#333' : '#fff',
            border: cond.value === 'sano' ? '1px solid #333' : 'none'
          }"
          @click="aplicarCondicion(cond.value)"
        >
          {{ cond.label }}
        </button>
        <button
          class="btn-condicion"
          style="background: #ccc; color: #333; border: none"
          @click="superficieActiva = null"
        >
          Cancelar
        </button>
      </div>
    </div>

    <div class="fila-label text-center mb-1"><strong>SUPERIOR</strong></div>
    <div class="fila-dientes justify-content-center">
      <div v-for="num in dientesSuperiores" :key="num" class="diente-wrapper">
        <div class="num-diente">{{ num }}</div>
        <svg :width="SIZE" :height="SIZE" @click.stop>
          <polygon
            v-for="sup in superficies"
            :key="sup.key"
            :points="sup.points"
            :fill="getColor(num, sup.key)"
            stroke="#333"
            stroke-width="1"
            style="cursor: pointer"
            @click="clickSuperficie($event, num, sup)"
          />
          <text
            v-if="getCondicion(num) === 'extraer' || getCondicion(num) === 'extraida'"
            x="20"
            y="24"
            text-anchor="middle"
            font-size="20"
            font-weight="bold"
            fill="#e53935"
            style="pointer-events: none"
          >
            X
          </text>
        </svg>
      </div>
    </div>

    <hr style="border: 2px solid #003a6e; margin: 8px 0" />

    <div class="fila-dientes justify-content-center">
      <div v-for="num in dientesInferiores" :key="num" class="diente-wrapper">
        <svg :width="SIZE" :height="SIZE" @click.stop>
          <polygon
            v-for="sup in superficies"
            :key="sup.key"
            :points="sup.points"
            :fill="getColor(num, sup.key)"
            stroke="#333"
            stroke-width="1"
            style="cursor: pointer"
            @click="clickSuperficie($event, num, sup)"
          />
          <text
            v-if="getCondicion(num) === 'extraer' || getCondicion(num) === 'extraida'"
            x="20"
            y="24"
            text-anchor="middle"
            font-size="20"
            font-weight="bold"
            fill="#e53935"
            style="pointer-events: none"
          >
            X
          </text>
        </svg>
        <div class="num-diente">{{ num }}</div>
      </div>
    </div>

    <hr style="border: 1px dashed #aaa; margin: 12px 0" />

    <div class="fila-label text-center mb-1">
      <strong>PEDIÁTRICO SUPERIOR</strong>
    </div>
    <div class="fila-dientes justify-content-center">
      <div v-for="num in dientesPedSuperiores" :key="num" class="diente-wrapper">
        <div class="num-diente">{{ num }}</div>
        <svg :width="SIZE_P" :height="SIZE_P" @click.stop>
          <polygon
            v-for="sup in superficiesP"
            :key="sup.key"
            :points="sup.points"
            :fill="getColor(num, sup.key)"
            stroke="#333"
            stroke-width="1"
            style="cursor: pointer"
            @click="clickSuperficie($event, num, sup)"
          />
        </svg>
      </div>
    </div>

    <hr style="border: 1px dashed #aaa; margin: 8px 0" />

    <div class="fila-dientes justify-content-center">
      <div v-for="num in dientesPedInferiores" :key="num" class="diente-wrapper">
        <svg :width="SIZE_P" :height="SIZE_P" @click.stop>
          <polygon
            v-for="sup in superficiesP"
            :key="sup.key"
            :points="sup.points"
            :fill="getColor(num, sup.key)"
            stroke="#333"
            stroke-width="1"
            style="cursor: pointer"
            @click="clickSuperficie($event, num, sup)"
          />
        </svg>
        <div class="num-diente">{{ num }}</div>
      </div>
    </div>

    <div class="field col-12 mt-4">
      <strong>OBSERVACIONES:</strong>
      <Textarea v-model="observaciones" rows="3" class="w-full" />
    </div>

    <DataTable v-if="resumen.length" :value="resumen" class="p-datatable-sm mt-3" stripedRows showGridlines>
      <Column header="#"
        ><template #body="s">{{ 1 + s.index }}</template></Column
      >
      <Column field="diente" header="PIEZA" />
      <Column field="cara" header="CARA" />
      <Column field="condicion" header="CONDICIÓN">
        <template #body="s">
          <span :style="{ color: getColorByValue(s.data.condicion), fontWeight: 'bold' }">
            {{ getLabelByValue(s.data.condicion) }}
          </span>
        </template>
      </Column>
      <Column header="QUITAR">
        <template #body="s">
          <Button
            icon="pi pi-times"
            class="p-button-rounded p-button-danger p-button-sm"
            @click="quitarCondicion(s.data)"
          />
        </template>
      </Column>
    </DataTable>

    <div class="flex justify-content-end mt-3 gap-2">
      <Button
        label="IMPRIMIR"
        icon="pi pi-print"
        class="p-button-danger p-button-lg"
        :disabled="!odontogramaId"
        v-tooltip.top="!odontogramaId ? 'Primero guarde el odontograma' : 'Imprimir'"
        @click="imprimir"
        :loading="imprimiendo"
      />
      <Button
        label="GUARDAR ODONTOGRAMA"
        icon="pi pi-save"
        class="p-button-info p-button-lg"
        :disabled="!hayDatos"
        @click="guardar"
        :loading="guardando"
      />
    </div>
  </div>
</template>

<script>
import PlanTratamientoService from '@/service/PlanTratamientoService'

const S = 40
const SP = 32
const M = S * 0.3
const MP = SP * 0.3

const generarSuperficies = (size, margen) => {
  const s = size,
    m = margen
  return [
    { key: 'V', label: 'Vestibular', points: `0,0 ${s},0 ${s - m},${m} ${m},${m}` },
    { key: 'L', label: 'Lingual', points: `0,${s} ${s},${s} ${s - m},${s - m} ${m},${s - m}` },
    { key: 'M', label: 'Mesial', points: `0,0 0,${s} ${m},${s - m} ${m},${m}` },
    { key: 'D', label: 'Distal', points: `${s},0 ${s},${s} ${s - m},${s - m} ${s - m},${m}` },
    { key: 'O', label: 'Oclusal', points: `${m},${m} ${s - m},${m} ${s - m},${s - m} ${m},${s - m}` }
  ]
}

export default {
  props: {
    medicos: { type: Array, default: () => [] },
    cliente_id: { type: Number, default: 0 },
    ubicacion_dental: { type: Array, default: () => [] }
  },
  data() {
    return {
      SIZE: S,
      SIZE_P: SP,
      superficies: generarSuperficies(S, M),
      superficiesP: generarSuperficies(SP, MP),

      dientesSuperiores: [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
      dientesInferiores: [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
      dientesPedSuperiores: [55, 54, 53, 52, 51, 61, 62, 63, 64, 65],
      dientesPedInferiores: [85, 84, 83, 82, 81, 71, 72, 73, 74, 75],

      condiciones: [
        { value: 'sano', label: 'Sano', color: '#ffffff' },
        { value: 'caries', label: 'Caries', color: '#dc3545' },
        { value: 'restauracion', label: 'Restauración', color: '#0066cc' },
        { value: 'extraer', label: 'Para Extraer', color: '#ff6600' },
        { value: 'extraida', label: 'Extraída', color: '#666666' },
        { value: 'tratamiento', label: 'Tratamiento', color: '#28a745' },
        { value: 'sellante', label: 'Sellante', color: '#e91e8c' },
        { value: 'tartaro', label: 'Tártaro', color: '#795548' }
      ],

      estado: {},
      superficieActiva: null,
      selectorStyle: {},
      observaciones: '',
      guardando: false,
      imprimiendo: false,
      odontogramaId: null
    }
  },
  computed: {
    resumen() {
      const items = []
      Object.entries(this.estado).forEach(([diente, caras]) => {
        Object.entries(caras).forEach(([cara, cond]) => {
          if (cond && cond !== 'sano') {
            items.push({ diente: parseInt(diente), cara, condicion: cond })
          }
        })
      })
      return items
    },
    hayDatos() {
      return this.resumen.length > 0 || this.observaciones.trim().length > 0
    }
  },
  created() {
    this.planTratamientoService = new PlanTratamientoService()
  },
  mounted() {
    document.addEventListener('click', this.cerrarSelector)
    this.cargarOdontograma()
  },
  beforeUnmount() {
    document.removeEventListener('click', this.cerrarSelector)
  },
  methods: {
    imprimir() {
      this.imprimiendo = true
      this.planTratamientoService.imprimirOdontograma({ cliente_id: this.cliente_id }).then(() => {
        this.imprimiendo = false
      })
    },
    cargarOdontograma() {
      if (!this.cliente_id) return
      this.planTratamientoService
        .getOdontogramaCliente({ cliente_id: this.cliente_id })
        .then((res) => {
          if (res.success && res.data) {
            this.estado = res.data.estado ? JSON.parse(res.data.estado) : {}
            this.observaciones = res.data.observaciones ?? ''
            this.odontogramaId = res.data.id ?? null
          }
        })
        .catch(() => {})
    },
    getColor(diente, cara) {
      const cond = this.estado[diente]?.[cara]
      if (!cond || cond === 'sano') return '#ffffff'
      return this.condiciones.find((c) => c.value === cond)?.color ?? '#ffffff'
    },
    getCondicion(diente) {
      const caras = this.estado[diente]
      if (!caras) return null
      if (Object.values(caras).includes('extraer')) return 'extraer'
      if (Object.values(caras).includes('extraida')) return 'extraida'
      return null
    },
    clickSuperficie(event, diente, sup) {
      event.stopPropagation()
      const rect = event.target.closest('svg').getBoundingClientRect()
      this.selectorStyle = {
        position: 'fixed',
        top: rect.bottom + 5 + 'px',
        left: rect.left + 'px'
      }
      this.superficieActiva = { diente, cara: sup.key, label: sup.label }
    },
    aplicarCondicion(valor) {
      const { diente, cara } = this.superficieActiva
      if (!this.estado[diente]) this.estado[diente] = {}
      if (valor === 'sano') {
        delete this.estado[diente][cara]
      } else {
        this.estado[diente][cara] = valor
      }
      this.estado = { ...this.estado }
      this.superficieActiva = null
    },
    quitarCondicion({ diente, cara }) {
      if (this.estado[diente]) {
        delete this.estado[diente][cara]
        this.estado = { ...this.estado }
      }
    },
    cerrarSelector() {
      this.superficieActiva = null
    },
    getColorByValue(val) {
      return this.condiciones.find((c) => c.value === val)?.color ?? '#333'
    },
    getLabelByValue(val) {
      return this.condiciones.find((c) => c.value === val)?.label ?? val
    },
    guardar() {
      this.guardando = true
      this.planTratamientoService
        .guardarOdontograma({
          cliente_id: this.cliente_id,
          estado: JSON.stringify(this.estado),
          observaciones: this.observaciones
        })
        .then((res) => {
          this.guardando = false
          if (res.success) {
            this.odontogramaId = res.data?.id ?? this.odontogramaId
            this.$toast.add({ severity: 'success', summary: 'Odontograma', detail: res.message, life: 2000 })
          } else {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 })
          }
        })
    }
  },
  watch: {
    cliente_id(val) {
      this.odontogramaId = null
      if (val) this.cargarOdontograma()
    }
  }
}
</script>

<style scoped>
.fila-dientes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 4px 0;
}
.fila-label {
  font-size: 12px;
  color: #003a6e;
}
.diente-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.num-diente {
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  color: #003a6e;
}
.selector-condicion {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 2px solid #003a6e;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  min-width: 180px;
}
.selector-header {
  font-weight: bold;
  font-size: 12px;
  color: #003a6e;
  margin-bottom: 6px;
  text-align: center;
}
.selector-opciones {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.btn-condicion {
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  text-align: left;
}
.btn-condicion:hover {
  opacity: 0.8;
}
svg polygon:hover {
  opacity: 0.7;
}
</style>